import React from 'react'
import ButtonStandard from '@/component/Primitive/ButtonStandard'
import styles from './CompanyButton.module.scss'
import { bool, node, string } from 'prop-types'
import cx from 'classnames'

const Index = (props) => {
  return (
    <ButtonStandard
      {...props}
      className={cx(
        styles.Button,
        props.outline && styles.ButtonOutline,
        props.isWhite && styles.IsWhite,
        props.classNames
      )}
      icon="arrow-right"
      size="small"
      primary
    >
      {props.children}
    </ButtonStandard>
  )
}

Index.propTypes = {
  children: node,
  outline: bool,
  classNames: string,
  isWhite: bool
}

export default Index
